import LoanIndex from '@/views/Loan/index';
import LoansActive from '@/views/Loan/LoansActive';
import LoansPending from '@/views/Loan/LoansPending';
import LoansOverdue from '@/views/Loan/LoansOverdue';
import LoansClosed from '@/views/Loan/LoansClosed';
import LoanDetails from '@/views/Loan/LoanDetails';
import { requiresLoanAccess } from '@/router/helpers';

export default [
  {
    path: '/loans',
    component: LoanIndex,
    beforeEnter: requiresLoanAccess,
    meta: {
      group: 'loans',
      roles: ['ADMINISTRATOR', 'CHIEF_LOAN_OFFICER', 'LOAN_OFFICER', 'COLLECTIONS_OFFICER'],
      title: 'Зээл',
    },
    children: [
      {
        path: '',
        name: 'LoansActive',
        component: LoansActive,
        meta: {
          roles: ['ADMINISTRATOR', 'CHIEF_LOAN_OFFICER', 'LOAN_OFFICER'],
        },
      },
      {
        path: 'pending',
        name: 'LoansPending',
        component: LoansPending,
        meta: {
          roles: ['ADMINISTRATOR', 'CHIEF_LOAN_OFFICER', 'LOAN_OFFICER'],
        },
      },
      {
        path: 'overdue',
        name: 'LoansOverdue',
        component: LoansOverdue,
        meta: {
          roles: ['ADMINISTRATOR', 'CHIEF_LOAN_OFFICER', 'LOAN_OFFICER', 'COLLECTIONS_OFFICER'],
        },
      },
      {
        path: 'closed',
        name: 'LoansClosed',
        component: LoansClosed,
        meta: {
          roles: ['ADMINISTRATOR', 'CHIEF_LOAN_OFFICER', 'LOAN_OFFICER'],
        },
      },
      {
        path: ':loanId',
        name: 'LoanDetails',
        component: LoanDetails,
        meta: {
          roles: ['ADMINISTRATOR', 'CHIEF_LOAN_OFFICER', 'LOAN_OFFICER', 'COLLECTIONS_OFFICER'],
        },
      },
    ],
  },
];
